import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);
const THEME_KEY = 'rayogent-theme';

export function ThemeProvider({ children }) {
  // Light is the default look (bold local). A new storage key, so everyone starts on it once;
  // anyone can still switch to dark.
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      try { return localStorage.getItem(THEME_KEY) || 'light'; } catch { return 'light'; }
    }
    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    try { localStorage.setItem(THEME_KEY, theme); } catch { /* storage blocked: theme just isn't remembered */ }
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
}
